import styled from "styled-components";


export const StyledNetworkNotification = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding-block: 0.5rem;
  transition: transform var(--network-notification-transition-duration);

  &.show-notification {
    transform: translateY(0);
  }

  &.hide-notification {
    transform: translateY(calc(-1 * var(--network-notification-height)));
    transition-delay: var(--network-notification-dismiss-delay);
  }
`;
